@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as c;

.modal {
  padding: 0;
  width: 576px;

  @include c.containerMedia(v.$tablet-breakpoint) {
    max-width: calc(100% - 30px);
  }
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px;
  border-radius: 10px;
  background: v.$palette-white;
  box-shadow: v.$shadow-2;
  text-align: center;

  @include c.containerMedia(520px) {
    padding: 40px 20px 24px;
  }
}

.title {
  @include t.text(20px, 30px, 600);
  max-width: 440px;
  margin-bottom: 8px;
  color: v.$palette-gray-900;
}

.text {
  @include t.text(14px, 22px, 400);
  max-width: 440px;
  margin-bottom: 24px;
  color: v.$palette-gray-800;
}

.buttons {
  display: flex;
  gap: 16px;

  @include c.containerMedia(520px) {
    flex-direction: column-reverse;
    width: 100%;
  }
}

.cancelButton,
.primaryButton {
  @include t.text(16px, 26px, 600);
  justify-content: center;
  padding: 11px 24px;
  border-radius: 8px;
}

.cancelButton {
  color: v.$palette-gray-900;
  background-color: v.$palette-gray-100;
}

.primaryButton {
  text-decoration: none;

  &,
  &:hover,
  &:active,
  &:focus {
    color: v.$palette-pure-white;
  }
}

.closeBtn {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 22px;
  height: 22px;
  margin: 0;
  padding: 0;
  cursor: pointer;

  svg path {
    fill: v.$palette-gray-900;
  }
}
